import { render } from "./file.vue?vue&type=template&id=3ec0ed52&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import "./file.vue?vue&type=style&index=0&id=3ec0ed52&lang=scss"
import "./file.vue?vue&type=style&index=1&id=3ec0ed52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec0ed52"]])

export default __exports__